import { render, staticRenderFns } from "./productItemsList.vue?vue&type=template&id=4444545a&scoped=true&"
import script from "./productItemsList.vue?vue&type=script&lang=js&"
export * from "./productItemsList.vue?vue&type=script&lang=js&"
import style0 from "./productItemsList.vue?vue&type=style&index=0&id=4444545a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4444545a",
  null
  
)

export default component.exports